import { Link } from 'react-router-dom';
import { Cloud, Cpu, Users, BarChart3, ArrowRight, Cog } from 'lucide-react';

const services = [
  {
    id: 'oracle',
    icon: Cpu,
    title: 'Oracle Communication Consulting',
    description: 'Expert consultation for Oracle Communication Billing and Revenue Management (BRM). We help telecom providers optimize billing operations, streamline revenue workflows, and ensure seamless service provisioning.',
  },
  {
    id: 'billing',
    icon: BarChart3,
    title: 'Tailored Billing Platform',
    description: 'Custom billing solutions designed for your unique business needs. Our platform handles account creation, service provisioning, billing cycles, and invoice generation with precision.',
  },
  {
    id: 'crm',
    icon: Users,
    title: 'Tailored CRM System',
    description: 'Comprehensive CRM solutions to manage customer relationships, sales pipelines, user accounts, pricing plans, promotions, and customize interfaces with ease.',
  },
  {
    id: 'cloud',
    icon: Cloud,
    title: 'Cloud Migration And Automation',
    description: 'Seamless cloud migration strategies and automation solutions that reduce operational overhead, improve scalability, and enhance your infrastructure resilience.',
  },
  {
    id: 'staff',
    icon: Users,
    title: 'Staff Augmentation',
    description: 'Access top-tier IT talent to scale your teams quickly. Our staff augmentation services provide skilled professionals who integrate seamlessly with your existing workforce.',
  },
  {
    id: 'digital',
    icon: Cog,
    title: 'Digital Business Transformation',
    description: 'End-to-end digital transformation services that modernize your business processes, enhance customer experiences, and drive innovation across your organization.',
  },
];

const ServicesPage = () => {
  return (
    <main>
      {/* Hero */}
      <section className="relative min-h-[50vh] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1619410283995-43d9134e7656?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBlbnRlcnByaXNlJTIwc29mdHdhcmUlMjBhYnN0cmFjdHxlbnwwfHx8fDE3ODk3NzE2NTd8MA&ixlib=rb-4.1.0&q=85"
            alt="Services"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-navy/85" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pt-32 pb-16 w-full">
          <p className="text-xs font-mono uppercase tracking-[0.3em] text-amber mb-4">What We Offer</p>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-white tracking-tight" data-testid="services-page-title">
            Digital Services
          </h1>
          <p className="text-slate-300 mt-4 max-w-xl">
            Comprehensive technology solutions tailored to transform and optimize your business operations.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {services.map((service) => {
              const Icon = service.icon;
              return (
                <div
                  key={service.id}
                  id={service.id}
                  className="bg-surface border border-white/10 rounded-sm p-8 card-hover group"
                  data-testid={`service-${service.id}`}
                >
                  <div className="w-12 h-12 bg-amber/10 rounded-sm flex items-center justify-center mb-6 group-hover:bg-amber/20 transition-colors">
                    <Icon className="w-6 h-6 text-amber" />
                  </div>
                  <h3 className="font-heading text-lg font-bold text-white mb-3">{service.title}</h3>
                  <p className="text-sm text-slate-400 leading-relaxed mb-4">{service.description}</p>
                  <Link to="/contact" className="text-amber text-sm font-medium inline-flex items-center gap-1 hover:gap-2 transition-all">
                    Get Started <ArrowRight className="w-3.5 h-3.5" />
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-surface/30 border-y border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-heading text-2xl font-bold text-white mb-4">Need a custom solution?</h2>
          <p className="text-slate-400 mb-6 text-sm">Let our experts design the perfect solution for your business challenges.</p>
          <Link to="/contact" className="btn-amber rounded-sm text-sm inline-flex items-center gap-2">
            Contact Us <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </main>
  );
};

export default ServicesPage;
